import { Chip } from "@mui/material";

const tone = (statusTitle = "", status) => {
  const text = String(statusTitle || status || "").toLowerCase();
  if (text.includes("پرداخت") || text.includes("paid") || text === "3") {
    return "success";
  }
  if (text.includes("لغو") || text.includes("cancel")) return "error";
  if (text.includes("تأیید") || text.includes("approved") || text === "2") {
    return "info";
  }
  return "warning";
};

const PaymentStatusBadge = ({ status, statusTitle }) => (
  <Chip
    size="small"
    color={tone(statusTitle, status)}
    label={statusTitle || String(status ?? "—")}
    variant="outlined"
    data-testid="payment-status-badge"
  />
);

export default PaymentStatusBadge;
